import { Box, Grid, Paper } from '@mui/material';
import { accountSelectedSelector } from 'atoms';
import React from 'react';
import { useRecoilValue } from 'recoil';
import Timeline from './Timeline';
import AccountData from './AccountData';
import ErrorBoundary from 'components/ErrorBoundary';
import { ErrorBoundaryContent } from 'components/ErrorBoundary/ErrorBoundary';
import Cameras from './Cameras';
import RequirePermission from 'components/RequirePermission';
import { Navigate } from 'react-router-dom';

function PlacePage() {
  const accountSelected = useRecoilValue(accountSelectedSelector);

  if (!accountSelected) {
    return <Navigate to="/" />;
  }

  return (
    <Grid container spacing={2} height="100%">
      <Grid
        item
        xs={12}
        md={4}
        sx={{ maxHeight: '100%', display: 'flex', flexDirection: 'column' }}
      >
        <ErrorBoundary
          key={accountSelected.id}
          reloadChildrenOnTryAgain
          tryAgainClick={() => {}}
          fallback={(props) => (
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                flex: '1 1 auto',
              }}
            >
              <ErrorBoundaryContent {...props} />
            </Paper>
          )}
        >
          <Timeline account={accountSelected} />
        </ErrorBoundary>
      </Grid>
      <Grid
        item
        xs={12}
        md={8}
        sx={{
          maxHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ pr: 0.5, overflow: 'auto' }}>
          <RequirePermission
            validatePermission={(account) => !!account?.hasPermissionToViewCameras}
          >
            <ErrorBoundary
              key={accountSelected.id}
              reloadChildrenOnTryAgain
              tryAgainClick={() => {}}
              fallback={(props) => (
                <Paper
                  variant="outlined"
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    flex: '1 1 auto',
                    p: 2,
                    mb: 2,
                  }}
                >
                  <ErrorBoundaryContent {...props} />
                </Paper>
              )}
            >
              <Cameras accountSelected={accountSelected} />
            </ErrorBoundary>
          </RequirePermission>
          <AccountData accountSelected={accountSelected} />
        </Box>
      </Grid>
    </Grid>
  );
}

export default PlacePage;
